import InteractiveSelector from "@/components/ui/interactive-selector";

const LocalAttractions = () => {
  return (
    <section id="experiences" className="relative">
      <InteractiveSelector />
    </section>
  );
};

export default LocalAttractions;
